module.exports = __webpack_public_path__ + "img/d07f6ca.jpg";